import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-maintenance-single-details",
  templateUrl: "./maintenance-single-details.component.html",
  styleUrls: ["./maintenance-single-details.component.css"],
})
export class MaintenanceSingleDetailsComponent implements OnInit {
  tphours: any = "00";
  tpminutes: any = "00";
  tptype: any = "AM";

  hours: any = "00";
  minutes: any = "00";
  tshours: any = "00";
  tsminutes: any = "00";
  tstype: any = "AM";

  starttime: any = "";
  endtime: any = "";

  isReviewTimeShown: boolean = false;
  isReviewTimeShownTs: boolean = false;
  isDateEmpty: boolean = false;
  isTimeError: boolean = false;
  isTimeEmpty: boolean = false;
  isDurationEmpty: boolean = false;
  isSpecifictime: boolean = true;
  isCertainduration: boolean = false;

  disableIncreaseHrs: boolean = false;
  disableDecreaseHrs: boolean = false;
  disableIncreaseMins: boolean = false;
  disableDecreaseMins: boolean = false;
  disableIncreaseHrsts: boolean = false;
  disableDecreaseHrsts: boolean = false;
  disableIncreaseMinsts: boolean = false;
  disableDecreaseMinsts: boolean = false;
  disableIncreaseHours: boolean = false;
  disableDecreaseHours: boolean = false;
  disableIncreaseMinutes: boolean = false;
  disableDecreaseMinutes: boolean = false;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {}

  @Output() gobacktostep2 = new EventEmitter<any>();
  @Output() mSingleStep3Data = new EventEmitter<any>();

  maintenanceSchedule = this.formBuilder.group({
    radio5: ["specifictime", Validators.required],
  });

  reviewTimeEvent() {
    this.isReviewTimeShown = !this.isReviewTimeShown;
  }

  reviewTimeEventTs() {
    this.isReviewTimeShownTs = !this.isReviewTimeShownTs;
  }

  mStep3Event() {
    this.isReviewTimeShown = false;
    this.isReviewTimeShownTs = false;

    var dt = localStorage.getItem("selectedDates");
    dt =  dt.substring(1);
    dt.length < 1 ? (this.isDateEmpty = true) : (this.isDateEmpty = false);

    var shour =
      this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;
    var ehour =
      this.tstype === "AM" ? this.tshours : parseInt(this.tshours) + 12;

      console.log("dates of single---", shour , ehour);

    this.starttime = shour + ":" + this.tpminutes;
    this.endtime = ehour + ":" + this.tsminutes;

    var minusStartTime: any = shour + "." + this.tpminutes;
    var minusEndTime: any = ehour + "." + this.tsminutes;
    var t: any = parseFloat(minusEndTime) - parseFloat(minusStartTime);

    console.log("dates of single---", shour , ehour);

    console.log("diff", t, minusStartTime, minusEndTime);

    var totalDuration: any = t.toString().split(".");

    console.log("starttime", minusEndTime - minusStartTime);
    console.log("totalDuration", totalDuration);

    var n = totalDuration.length > 1 ? parseInt(totalDuration[1].slice(0, 2)) : 0;

    console.log("n", n);
  
    

    if (n > 59) {
      let a = n - 60;
      let b = n - (a + parseInt(this.tpminutes));
      totalDuration[1] = b >= 10 ? b.toString() : "0" + b;
    } else {
      totalDuration[1] = n >= 10 ? n.toString() : "0" + n;
    }

    console.log("totalDuration --->", totalDuration);

    if (this.isSpecifictime) {
      if (this.starttime > this.endtime) {
        this.isTimeError = true;
      } else {
        this.isTimeError = false;
      }

      if (this.starttime === this.endtime) {
        this.isTimeEmpty = true;
      } else {
        this.isTimeEmpty = false;
      }
    }

    if (
      this.isCertainduration &&
      parseInt(this.hours) === 0 &&
      parseInt(this.minutes) === 0
    ) {
      this.isDurationEmpty = true;
    } else {
      this.isDurationEmpty = false;
    }

    if (this.isSpecifictime) {
      if (!this.isTimeError && !this.isTimeEmpty && !this.isDateEmpty) {
        this.mSingleStep3Data.emit({
          startTime: {
            hours: shour.toString(),
            minutes: this.tpminutes.toString(),
          },
          end: {
            endTime: {
              hours: ehour.toString(),
              minutes: this.tsminutes.toString(),
              totalDuration: (
                totalDuration[0] +
                ":" +
                totalDuration[1]
              ).toString(),
            },
            duration: {
              hours: totalDuration[0],
              minutes: totalDuration[1],
            },
            isEndTime: true,
          },
        });
      }
    } else {
      if (!this.isTimeError && !this.isDurationEmpty && !this.isDateEmpty) {
        this.mSingleStep3Data.emit({
          startTime: {
            hours: shour.toString(),
            minutes: this.tpminutes.toString(),
          },
          end: {
            endTime: {
              hours: ehour.toString(),
              minutes: this.tsminutes.toString(),
              totalDuration: (this.hours + ":" + this.minutes).toString(),
            },
            duration: {
              hours: this.hours,
              minutes: this.minutes,
            },
            isEndTime: false,
          },
        });
      }
    }
  }

  increaseHrs() {
    var hrs = parseInt(this.tphours) + 1;
    this.disableDecreaseHrs = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (hrs >= 12) {
      this.tphours = 12;
      this.disableIncreaseHrs = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableIncreaseHrs = false;
    }
  }

  decreaseHrs() {
    var hrs = parseInt(this.tphours) - 1;
    this.disableIncreaseHrs = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (hrs <= 0) {
      this.tphours = "00";
      this.disableDecreaseHrs = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableDecreaseHrs = false;
    }
  }

  increaseMins() {
    var mins = parseInt(this.tpminutes) + 1;
    this.disableDecreaseMins = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (mins > 59) {
      this.disableIncreaseMins = true;
    } else {
      this.disableIncreaseMins = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMins() {
    var mins = parseInt(this.tpminutes);
    this.disableIncreaseMins = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (mins === 0) {
      this.disableDecreaseMins = true;
      this.tpminutes = "00";
    } else {
      mins = parseInt(this.tpminutes) - 1;
      this.disableDecreaseMins = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  increaseHrsts() {
    var hrs = parseInt(this.tshours) + 1;
    this.disableDecreaseHrsts = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (hrs >= 12) {
      this.tshours = 12;
      this.disableIncreaseHrsts = true;
    } else {
      this.tshours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableIncreaseHrsts = false;
    }
  }

  decreaseHrsts() {
    var hrs = parseInt(this.tshours) - 1;
    this.disableIncreaseHrsts = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (hrs <= 0) {
      this.tshours = "00";
      this.disableDecreaseHrsts = true;
    } else {
      this.tshours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableDecreaseHrsts = false;
    }
  }

  increaseMinsts() {
    var mins = parseInt(this.tsminutes) + 1;
    this.disableDecreaseMinsts = false;
    this.isTimeError = false;
    this.isTimeEmpty = false;
    if (mins > 59) {
      this.disableIncreaseMinsts = true;
    } else {
      this.disableIncreaseMinsts = false;
      this.tsminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMinsts() {
    var mins = parseInt(this.tsminutes);
    this.disableIncreaseMinsts = false;
    this.isTimeEmpty = false;
    this.isTimeError = false;
    if (mins === 0) {
      this.disableDecreaseMinsts = true;
      this.tsminutes = "00";
    } else {
      mins = parseInt(this.tsminutes) - 1;
      this.disableDecreaseMinsts = false;
      this.tsminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  back() {
    this.gobacktostep2.emit();
  }

  changetimeformat() {
    var f = this.tptype;
    f === "AM" ? (this.tptype = "PM") : (this.tptype = "AM");
  }

  changetimeformatts() {
    var f = this.tstype;
    f === "AM" ? (this.tstype = "PM") : (this.tstype = "AM");
  }

  specifictime() {
    this.tshours = "00";
    this.tsminutes = "00";
    this.tstype = "AM";
    this.isSpecifictime = true;
    this.isCertainduration = false;
    this.isTimeEmpty = false;
    this.isDurationEmpty = false;
  }

  certainduration() {
    this.tshours = "00";
    this.tsminutes = "00";
    this.tstype = "AM";
    this.isSpecifictime = false;
    this.isCertainduration = true;
    this.isTimeEmpty = false;
    this.isDurationEmpty = false;
  }

  increaseHours() {
    var hrs = parseInt(this.hours) + 1;
    this.isDurationEmpty = false;
    this.disableDecreaseHours = false;
    if (hrs === 24) {
      this.disableIncreaseHours = true;
      this.disableIncreaseMinutes = true;
      this.disableDecreaseMinutes = true;
      this.hours = "24";
      this.minutes = "00";
    } else {
      this.disableIncreaseHours = false;
      this.hours = hrs >= 10 ? hrs : "0" + hrs;
    }
  }

  decreaseHours() {
    var hrs = parseInt(this.hours) - 1;
    this.isDurationEmpty = false;
    this.disableIncreaseHours = false;
    this.disableIncreaseMinutes = false;
    if (hrs === 0) {
      this.disableDecreaseHours = true;
      this.hours = "00";
    } else {
      this.disableDecreaseHours = false;
      this.hours = hrs >= 10 ? hrs : "0" + hrs;
    }
  }

  increaseMinutes() {
    var mins = parseInt(this.minutes) + 1;
    this.isDurationEmpty = false;
    this.disableDecreaseMinutes = false;
    if (mins > 59) {
      this.disableIncreaseMinutes = true;
    } else {
      this.disableIncreaseMinutes = false;
      this.minutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMinutes() {
    var mins = parseInt(this.minutes);
    this.isDurationEmpty = false;
    this.disableIncreaseMinutes = false;
    if (mins === 0) {
      this.disableDecreaseMinutes = true;
      this.minutes = "00";
    } else {
      mins = parseInt(this.minutes) - 1;
      this.disableDecreaseMinutes = false;
      this.minutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  closeTime() {
    this.isReviewTimeShown = false;
  }

  closeTimeTs() {
    this.isReviewTimeShownTs = false;
  }
}
